/*
  NOTE: THIS IS A TEMPORARY SOLUTION TO ALLOW FOLLOWING ON THE PROFILE PAGE
  UNTIL WE ARE ABLE TO IMPLEMENT THE NEW PROFILE EXPERIENCE. USING THIS COMPONENT WILL
  REQUIRE RUNNING THE APPLICATION WITH SSL IN DEVELOPMENT.
*/

import React, { useState, useEffect } from 'react';
import { getUserConnectionStatus, userActionRequest } from '@alltrails/shared/utils/requests/belayRequests';
import { addActionsToConnection } from '@alltrails/shared/utils/community/belayHelpers';
import { UserConnection, BelayUserConnection, UserConnectionActionType } from '@alltrails/shared/types/belay';
import { RequestState } from '@alltrails/shared/types/blazes';
import logError from '../utils/logError';

type ActionRequestStates = 'idle' | 'loading' | 'succeeded' | 'failed';

const useUserConnectionActions = (userId: number, otherUserId: number): [UserConnection, (userActionKey: UserConnectionActionType) => void] => {
  const [userConnection, setUserConnection] = useState<UserConnection>();

  const formatUserConnection = (resp: { data: BelayUserConnection }) => {
    setUserConnection(addActionsToConnection(resp.data));
  };

  useEffect(() => {
    getUserConnectionStatus(userId, otherUserId).then(formatUserConnection).catch(logError);
  }, []);

  const setRequestState = (userActionKey: UserConnectionActionType, requestState: ActionRequestStates) => {
    setUserConnection((prevState: UserConnection) => {
      return {
        ...prevState,
        actions: { ...prevState.actions, [userActionKey]: { ...prevState.actions[userActionKey], requestState } }
      };
    });
  };

  const takeUserAction = (userActionKey: UserConnectionActionType) => {
    if (!userConnection?.actions[userActionKey]) return;
    const { href, method } = userConnection.actions[userActionKey];
    // set loading state;
    setRequestState(userActionKey, RequestState.Loading);
    // makeRequest
    userActionRequest(href, method)
      .then(formatUserConnection)
      .catch((err: Error) => {
        setRequestState(userActionKey, RequestState.Idle);
        logError(err);
      });
  };

  return [userConnection, takeUserAction];
};

export default useUserConnectionActions;
